import { SerializedError } from '@databases/types';
import { Space } from '@databases/types/confluence';

import { SpaceInfo } from '../../confluence/space';
import { PayloadAction, createSlice } from '../../shims/redux-toolkit';
import { AsyncOperation, AsyncOperationStatus } from '../redux';

export interface SpacesState {
  spaceInfo: Record<string, SpaceInfo>;
  spaceInfoStatus: Record<string, AsyncOperation<void>>;

  spaces?: Space[] | undefined;
  spacesStatus?: AsyncOperation<void>;
}

const initialState: SpacesState = {
  spaceInfo: {},
  spaceInfoStatus: {},
};

const spacesSlice = createSlice({
  name: 'spaces',
  initialState,
  reducers: {
    loadSpaceInfoPending: (state, action: PayloadAction<{ spaceKey: string }>) => {
      const { spaceKey } = action.payload;
      state.spaceInfoStatus[spaceKey] = { status: AsyncOperationStatus.PENDING };
    },

    loadSpaceInfoFinished: (state, action: PayloadAction<SpaceInfo>) => {
      const spaceInfo = action.payload;
      state.spaceInfoStatus[spaceInfo.key] = { status: AsyncOperationStatus.SUCCEEDED };
      state.spaceInfo[spaceInfo.key] = spaceInfo;
    },

    loadSpaceInfoError: (
      state,
      action: PayloadAction<{ spaceKey: string; error: SerializedError }>
    ) => {
      const { spaceKey, error } = action.payload;
      state.spaceInfoStatus[spaceKey] = { status: AsyncOperationStatus.ERROR, error };
    },

    loadSpacesPending: (state) => {
      state.spacesStatus = { status: AsyncOperationStatus.PENDING };
    },

    loadSpacesFinished: (state, action: PayloadAction<Space[]>) => {
      const spaces = action.payload;
      state.spacesStatus = { status: AsyncOperationStatus.SUCCEEDED };
      state.spaces = spaces;
    },

    loadSpacesError: (state, action: PayloadAction<{ error: SerializedError }>) => {
      const { error } = action.payload;
      state.spacesStatus = { status: AsyncOperationStatus.ERROR, error };
    },
  },
});

export default spacesSlice;
